<template>
  <booking-home />
</template>

<script>
import BookingHome from "@/components/3pl/Operations/Bookings/Home/Index";
export default {
  components: {
    BookingHome,
  },
};
</script>

<style></style>
